import initials from "../assets/initials.png"

export default function Footer() {
    return(
        <div className="w-screen bg-stone-900 flex flex-col md:flex-row md:justify-between md:px-[50px] py-[50px] text-stone-500">
            <div>
                <a href=""><img src={initials} className="h-16 opacity-20"/></a>
                <p className="pl-3">
                    © CodeWave Solutions, 2024 <br />
                    All Rights Reserved
                </p>
            </div>
            <div className="md:text-right">
                <p className="pl-3 md:pt-16">
                    <a className="text-stone-500">Terms & Conditions</a> <br />
                    <a className="text-stone-500">Privacy Policy</a>
                </p>
            </div>
        </div>
    );
}